import React, { useCallback, useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { getDedicatedFormPage } from "./dedicatedForms";
import GenericFormPrintSheet from "./GenericFormPrintSheet";

/**
 * One clinical form print sheet — dedicated layout when registered, otherwise
 * the generic label/value sheet. Shared by single and bulk print pages.
 */
const ClinicalFormPrintBlock = ({ patient, clinicalForm, onReady }) => {
  const DedicatedForm = getDedicatedFormPage(clinicalForm?.formType);
  const [failed, setFailed] = useState(false);
  const onReadyRef = useRef(onReady);
  onReadyRef.current = onReady;

  const handleReady = useCallback(() => {
    onReadyRef.current?.();
  }, []);

  useEffect(() => {
    if (!clinicalForm) return;
    if (!DedicatedForm) onReadyRef.current?.();
  }, [clinicalForm, DedicatedForm]);

  if (!clinicalForm || failed) return null;

  if (DedicatedForm) {
    return (
      <DedicatedForm
        patient={patient}
        clinicalForm={clinicalForm}
        printMode
        onReady={handleReady}
        onBack={() => {
          setFailed(true);
          onReadyRef.current?.();
        }}
      />
    );
  }

  return <GenericFormPrintSheet patient={patient} clinicalForm={clinicalForm} />;
};

ClinicalFormPrintBlock.propTypes = {
  patient: PropTypes.object,
  clinicalForm: PropTypes.object,
  onReady: PropTypes.func,
};

export default ClinicalFormPrintBlock;
